import { Document } from "@react-pdf/renderer";
import {
  BasicInfoPage,
  PresentationPage,
  TableTallyPage,
  WbdSecondPage,
  WbdLastPageVert,
  WbdFirstPageESP,
  WbdFirstPageGL,
  WbdFirstPageSRP,
  WbdFirstPageGlPacker,
  WbdFirstPageEspSL,
  Wellbore3dpage,
  WbdLastPageHor,
  GasSimulatorPage,
  WbdFirstPagePCP,
  WbdFirstPageGenVert,
} from "../pages";
import { DataProps, UnitSystem } from "../../../interfaces/interfaces";
import { SandSimulatorPage } from "../pages/solution/SandSimulatorPage";
import { PmmGuardianSimulatorPage } from "../pages/solution/PmmGuardianSimulatorPage";
import { PressSimulatorPage } from "../pages/solution/PressSimulatorPage";
import { WbdFirstPageGen } from "../pages/wbd/WbdFirstPageGen";
import React from "react";
import { GasSimulatorVortexPage } from "../pages/solution/GasSimulatorVortexPage";
import { PdfTVSChart } from "../pages/charts/PdfTVSChart";

export const PdfProposalFile = ({
  data,
  unitSystem = 'imperial' as UnitSystem,
  tallyUnitSystem,
}: {
  data: DataProps;
  unitSystem?: UnitSystem;
  tallyUnitSystem?: UnitSystem | null;
}) => {
  return (
    <Document>
      <>
        <PresentationPage data={data} />
        <BasicInfoPage data={data} unitSystem={unitSystem} />
        {data.solution.gasSolution ? (
          <>
            {data.simulator.gas.vortex ? (
              <GasSimulatorVortexPage
                data={data.solution.gasSimulator.data as any}
              />
            ) : (
              <GasSimulatorPage
                data={data.solution.gasSimulator.data}
                results={data.solution.gasSimulator.results}
                simulatorState={data.simulator}
              />
            )}
          </>
        ) : null}
        {data.solution.sandSolution ? (
          <SandSimulatorPage
            data={data.solution.sandSimulator.data}
            results={data.solution.sandSimulator.results}
            simulatorState={data.simulator}
          />
        ) : null}
        {data.solution.pmmGuardianSolution ? (
          <PmmGuardianSimulatorPage
            data={data.solution.pmmGuardianSimulator.data}
            results={data.solution.pmmGuardianSimulator.results}
          />
        ) : null}
        {data.solution.pressureSolution ? (
          <PressSimulatorPage
            data={data.solution.pressureSimulator.data}
            results={data.solution.pressureSimulator.results}
            simulatorState={data.simulator}
          />
        ) : null}
        {data.wellbore3dImg ? <Wellbore3dpage data={data} /> : null}
        {data.tallyDesign.length > 0 ? (
          <TableTallyPage
            data={data}
            unitSystem={tallyUnitSystem ?? unitSystem}
          />
        ) : null}
        {data.basicInfo.tvdVs && data.basicInfo.tvdVs?.length > 0 ? (
          <PdfTVSChart
            dataPoints={data.basicInfo.tvdVs}
            annotations={data.basicInfo.tvdVsAnnotations}
          />
        ) : null}
        {data.designByPage?.length > 0 &&
          data.designByPage?.length !== 1 &&
          data.designByPage.map((itemsByPage, index) =>
            index === 0 && itemsByPage.length > 0 ? (
              <React.Fragment key={index}>
                {data.basicInfo.sla.id === 0 ? (
                  <WbdFirstPageSRP
                    tools={itemsByPage}
                    key={index}
                    data={data}
                    unitSystem={unitSystem}
                  />
                ) : null}
                {data.basicInfo.sla.id === 1
                  ? !data.basicInfo.bhaInfo?.sandLift && (
                      <WbdFirstPageESP
                        tools={itemsByPage}
                        data={data}
                        key={index}
                        unitSystem={unitSystem}
                      />
                    )
                  : null}
                {data.basicInfo.sla.id === 1
                  ? data.basicInfo.bhaInfo?.sandLift && (
                      <WbdFirstPageEspSL
                        tools={itemsByPage}
                        data={data}
                        key={index}
                        unitSystem={unitSystem}
                      />
                    )
                  : null}
                {data.basicInfo.sla.id === 2
                  ? !data.basicInfo.bhaInfo?.glPacker && (
                      <WbdFirstPageGL
                        tools={itemsByPage}
                        data={data}
                        key={index}
                        unitSystem={unitSystem}
                      />
                    )
                  : null}
                {data.basicInfo.sla.id === 2
                  ? data.basicInfo.bhaInfo?.glPacker && (
                      <WbdFirstPageGlPacker
                        tools={itemsByPage}
                        data={data}
                        key={index}
                        unitSystem={unitSystem}
                      />
                    )
                  : null}
                {data.basicInfo.sla.id === 3 ? (
                  <WbdFirstPagePCP
                    tools={itemsByPage}
                    data={data}
                    key={index}
                    unitSystem={unitSystem}
                  />
                ) : null}
              </React.Fragment>
            ) : index > 0 &&
              index < data.designByPage.length - 1 &&
              itemsByPage.length > 0 ? (
              <WbdSecondPage tools={itemsByPage} data={data} key={index} unitSystem={unitSystem} />
            ) : (
              index === data.designByPage.length - 1 &&
              itemsByPage.length > 0 && (
                <>
                  {data.basicInfo.bhaInfo?.horizontal ? (
                    <WbdLastPageHor
                      tools={itemsByPage}
                      key={index}
                      data={data}
                      unitSystem={unitSystem}
                    />
                  ) : (
                    <WbdLastPageVert
                      tools={itemsByPage}
                      key={index}
                      data={data}
                      unitSystem={unitSystem}
                    />
                  )}
                </>
              )
            ),
          )}
        {data.designByPage?.length === 1 ? (
          <>
            {data.basicInfo.bhaInfo?.horizontal ? (
              <WbdFirstPageGen
                tools={data.designByPage[0]}
                slaId={data.basicInfo.sla.id}
                data={data}
                unitSystem={unitSystem}
              />
            ) : (
              <WbdFirstPageGenVert
                tools={data.designByPage[0]}
                slaId={data.basicInfo.sla.id}
                data={data}
                unitSystem={unitSystem}
              />
            )}
          </>
        ) : null}
      </>
    </Document>
  );
};
